exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forgotten-password-container{width:100%;text-align:center}.forgotten-password-container button{background-color:unset;color:#0078dc;border:none}.forgotten-password-container button:hover{text-decoration:underline;color:#005ca9}", ""]);

// exports
